import { GET_CARRIER_TYPES, GET_CARRIER_TYPES_SUCCESS, GET_CARRIER_TYPES_ERROR } from "./actionTypes";

const initialState = {
  errorGetCarrierTypes: "",
  loadingGetCarrierTypes: false,
  carrier_types: null,
  successGetCarrierTypes: "",
};

const getCarrierTypes = (state = initialState, action) => {
  switch (action.type) {
    case GET_CARRIER_TYPES:
      state = {
        ...state,
        loadingGetCarrierTypes: true,
      };
      break;
    case GET_CARRIER_TYPES_SUCCESS:
      state = {
        ...state,
        loadingGetCarrierTypes: false,
        carrier_types: action.payload.carrier_types,
        successGetCarrierTypes: action.payload.message,
      };
      break;
    case GET_CARRIER_TYPES_ERROR:
      state = { ...state, errorGetCarrierTypes: action.payload, loadingGetCarrierTypes: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getCarrierTypes;
